import { billingTransactionBaseModel } from './crud';

import { useFetchAppointmentTransactionManyHook } from './useFetchAppointmentTransactionMany';
import { useFetchBillingTransactionSummaryManyHook } from './useFetchBillingTransactionSummaryMany';

export * from './types';
export const billingTransactionModelKeys = billingTransactionBaseModel.keys;

export const useBillingTransactionById =
  billingTransactionBaseModel.fetchById();
export const useBillingTransactionByIds =
  billingTransactionBaseModel.fetchByIds();
export const useBillingTransactionMany =
  billingTransactionBaseModel.fetchMany();
export const useBillingTransactionCount = billingTransactionBaseModel.count();
export const useBillingTransactionManyInfiniteQuery =
  billingTransactionBaseModel.fetchPaginated();
export const useBillingTransactionUpdateOne =
  billingTransactionBaseModel.edit();
export const useBillingTransactionCreateOne =
  billingTransactionBaseModel.create();
export const useBillingTransactionRemoveOne =
  billingTransactionBaseModel.delete();
export const useBillingTransactionRemoveByIds =
  billingTransactionBaseModel.deleteByIds();

export const useBillingTransactionByIdV2 =
  billingTransactionBaseModel.fetchByIdV2();
export const useBillingTransactionByIdsV2 =
  billingTransactionBaseModel.fetchByIdsV2();
export const useBillingTransactionManyV2 =
  billingTransactionBaseModel.fetchManyV2();
export const useBillingTransactionCountV2 =
  billingTransactionBaseModel.countV2();
export const useBillingTransactionManyInfiniteQueryV2 =
  billingTransactionBaseModel.fetchPaginatedV2();
export const useBillingTransactionUpdateOneV2 =
  billingTransactionBaseModel.editV2();
export const useBillingTransactionCreateOneV2 =
  billingTransactionBaseModel.createV2();
export const useBillingTransactionRemoveOneV2 =
  billingTransactionBaseModel.deleteV2();
export const useBillingTransactionRemoveByIdsV2 =
  billingTransactionBaseModel.deleteByIdsV2();

export const useFetchAppointmentTransactionMany =
  useFetchAppointmentTransactionManyHook;
export const useFetchBillingTransactionSummaryMany =
  useFetchBillingTransactionSummaryManyHook;

export const useBillingTransactionPagination =
  billingTransactionBaseModel.fetchPaginated();
export const useBillingTransactionPaginationV2 =
  billingTransactionBaseModel.fetchPaginatedV2();
